export default (actual, max) => {
  let fmtString;
  fmtString = actual === 0 ? "-" : actual;
  if (actual === 0) {
    fmtString = "-";
  } else {
    fmtString = `${actual} / ${max === -1 ? "∞" : max}`;
  }
  return fmtString;
};
